/**
 * User: itaik
 * Date: 7/3/13
 * jquery registered plugin for "touching" the application session and extending its time
 * The plugin just references the an API on the sessionManager of the LE application.
 * We use jquery a global place, so modules outside the LE application (such as jquery.crossdomain.js) could use the touched method
 */
define(function (require) {
    'use strict';

    var jQuery = require('jquery');

    (function ($, window, document, undefined) {
        var pluginName = 'liveEngageSession';

        var methods = {
            initialize: function(sessionManager) {
                this.sessionManager = sessionManager;
            },
            touched: function() {
                if (this.sessionManager) {
                    this.sessionManager.touched();
                } else {
                    //$.error(pluginName + ' had not been initialized with the sessionManager');
                    // TODO might be cases that there is no session manager (such as unit tests for registration module) - think about a better way to verify that object has been initialized
                }
            }
        };

        $[pluginName] = function (method) {
            if (methods[method] && !method.match("^_")) {
                return methods[method].apply(this, [].slice.call(arguments, 1));
            }

            $.error('Method ' + method + ' does not exist in jquery.' + pluginName);
        };
    })(jQuery, window, document);
});